import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/proveedor';
import ProveedorList from './ProveedoresList';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_proveedor,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ProveedorList);
